import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector.js';
import useSortData from "../Pagination/SortData";

import { Tree, TreeNode } from "react-organizational-chart";
import styled from "styled-components";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";



import "../../components/orgtrapper.css";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const Organzationtree = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;




	const [parent, setParent] = useState('');
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);
	const [cnt, setCnt] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(true);

	const { sortConfig, sortData, handleSort } = useSortData();

  const [zoom, setZoom] = useState(1);


  const [showPopup, setShowPopup] = useState(false);
const [popupTitle, setPopupTitle] = useState("");
const [popupEmployees, setPopupEmployees] = useState([]);

const sectionRef = React.useRef(null);
const treeRef = React.useRef(null);
const firstMatchRef = React.useRef(null);


const [searchValue, setSearchValue] = useState("");


	


	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [entriesPerPage,setEntriesPerPage]=useState(10);
	let filteredItems = data.filter((item) =>



		`${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}${item.applied_on.toLowerCase()}${item.releaved_on.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

	const sortedItems = sortData(filteredItems);
const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);

	const [checkedItems, setCheckedItems] = useState({});

	
	// const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	// const handleRowsPerPageChange = (e) => {
	// 	setItemsPerPage(Number(e.target.value));
	// 	setCurrentPage(1); // Reset to first page
	// };



	useEffect(() => {
		axios.get(API_BASE_URL + '/nodue_dept_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then((res) =>{
				setData(res.data);
// 				const defaultChecked = {};
//   res.data.forEach(item => {
// 	if(item.hr_status_id == 1){
//     defaultChecked[item.id] = true;
// 	}
//   });
//   setCheckedItems(defaultChecked);
			}) 
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])




	

	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);




useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.get(API_BASE_URL + "/gethrExitListcnt", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        },
      });
      // console.log(response.data);
      
      setCnt(response.data);
      // console.log("Exit Procedures Count:", cnt.exitProceduresCount);
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);


const columns = [
  { label: "Employee", key: "employee_name", sortable: true },
  { label: "Department", key: "department_name", sortable: true },
  { label: "Applied On", key: "applied_on", sortable: true },
  { label: "Releaved On", key: "releaved_on", sortable: true }
];


const Card = styled.div`
  padding: 10px 14px;
  border-radius: 6px;
  background: #fff;
  border-left: 5px solid #38b2ac;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  width: 220px;
  text-align: left;
`;

const Name = styled.div`
  font-weight: 600;
`;

const Role = styled.div`
  font-size: 13px;
  color: #555;
`;

const EmpId = styled.div`
  font-size: 15px;
  color: #555;
  font-weight: 900;
`;



const [orgTree, setOrgTree] = useState(null);


// useEffect(() => {
//   axios
//     .post(API_BASE_URL + "/getOrganizationTree", {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//       },
//     })
//     .then((res) => {
//       setOrgTree(res.data);

// 	  console.log(res.data);
//       setLoading(false);
//     })
//     .catch((err) => {
//       console.error(err);
//       setLoading(false);
//     });
// }, []);

const flattenEmployees = (tree) => {
  if (!tree) return [];
  let list = [];

  tree.children.forEach(group => {
    group.children.forEach(emp => {
      list.push(emp);
    });
  });

  return list;
};



const allEmployees = React.useMemo(
  () => flattenEmployees(orgTree),
  [orgTree]
);

const searchResults = React.useMemo(() => {
  if (!searchValue || !orgTree) return [];

  const q = normalize(searchValue);

  return allEmployees.filter(emp =>
    normalize(emp.name).includes(q) ||
    normalize(emp.emp_id).includes(q)
  );
}, [searchValue, allEmployees]);

const [selectedEmpId, setSelectedEmpId] = useState(null);

useEffect(() => {
  const fetchData = async () => {
	try {
	  const res = await axios.get(API_BASE_URL + "/organizationtree", {
		headers: {
		  Authorization: `Bearer ${localStorage.getItem("authToken")}`
		},
	  });
	  console.log(res.data);
	  
	  setOrgTree(res.data);
	  setLoading(false);
	  // console.log("Exit Procedures Count:", cnt.exitProceduresCount);
	} catch (err) {
	  console.error("Error fetching data:", err);
	  setError("Failed to fetch data");
	  setLoading(false);
	} finally {
	  setLoading(false);
	}
  };

fetchData();
}, []);


const [expanded, setExpanded] = useState({});
const [childrenMap, setChildrenMap] = useState({});


// const handleExpand = async (empId, empName = "") => {
//   try {
//     const res = await axios.get(
//       `${API_BASE_URL}/incharge/${empId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("authToken")}`
//         }
//       }
//     );

//     setPopupEmployees(res.data);
//     setPopupTitle(`Employees under ${empName}`);
//     setShowPopup(true);

//   } catch (err) {
//     console.error(err);
//   }
// };


const handleInchargeExpand = async (empId, empName = "",openPopup = true) => {

  
  try {
    const res = await axios.get(
      `${API_BASE_URL}/incharge/${empId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

     const list = res.data.data || res.data;

    // ✅ Always load table data
    setReportees(Array.isArray(list) ? list : []);

    // ✅ ONLY open popup when allowed
    if (openPopup) {
      setPopupEmployees(list);
      setPopupTitle(`Employees under Incharge ${empName}`);
      setShowPopup(true);
    }
  } catch (err) {
    console.error(err);
  }
};

const handleHodExpand = async (empId, empName = "") => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/hod/${empId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );

    setPopupEmployees(res.data);
    setPopupTitle(`Employees under HOD ${empName}`);
    setShowPopup(true);
  } catch (err) {
    console.error(err);
  }
};


useEffect(() => {
  if (selectedEmpId && firstMatchRef.current) {
    firstMatchRef.current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }
}, [selectedEmpId]);




const NodeCard = ({
  name,
  department,
  emp_id,
  canExpand,
  onExpand,
  highlight,
  nodeRef,
  onAddReporter,
  onViewChangelog
}) => (
  <Card
    ref={nodeRef}
    style={{
      position: "relative",
      border: highlight ? "2px solid #ff9800" : "1px solid #38b2ac",
      background: highlight ? "#43bcec" : "#fff"
    }}
  >
    {/* ➕ Expand icon */}
    {canExpand && (
      <span
        style={{
          position: "absolute",
          left: "-22px",
          top: "35%",
          cursor: "pointer",
          fontSize: "18px",
          fontWeight: "bold"
        }}
        onClick={() => onExpand(emp_id, name)}
      >
        +
      </span>
    )}

    {/* ⋮ Three-dot menu */}
    <span
      style={{
        position: "absolute",
        top: "6px",
        right: "8px",
        cursor: "pointer",
        fontSize: "18px"
      }}
      onClick={(e) => {
        e.stopPropagation();
        setMenuOpenFor(emp_id);
      }}
    >
      ⋮
    </span>

    {/* Menu dropdown */}
    {/* {menuOpenFor === emp_id && (
      <div
        style={{
          position: "absolute",
          top: "28px",
          right: "8px",
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: "6px",
          zIndex: 2000,
          width: "140px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
        }}
      >
      

        <div
          style={{ padding: "8px", cursor: "pointer",fontSize:'12px' }}
          onClick={() => {
            onAddReporter({ emp_id, name });
            setMenuOpenFor(null);
          }}
        >
          Add Reporter(s)
        </div>
      </div>
    )} */}

    <Name>{name}</Name>
    <Role>{department}</Role>
    <EmpId>({emp_id})</EmpId>
  </Card>
);





// const NodeCard = ({ name, department, emp_id }) => (
//   <Card>
//     <Name>{name}</Name>
//     <Role>{department}</Role>
//     <EmpId>Emp ID - {emp_id}</EmpId>
//   </Card>
// );

const downloadPDF = () => {
  const doc = new jsPDF("p", "mm", "a4");

  doc.setFontSize(16);
  doc.text(popupTitle, 14, 15);

  const tableData = popupEmployees.map((emp, index) => [
    index + 1,
    emp.name || "",
    emp.department || "",
    emp.emp_id || ""
  ]);

  autoTable(doc, {
    startY: 25,
    head: [["#", "Employee Name", "Department", "Emp ID"]],
    body: tableData,
    styles: { fontSize: 10 },
    headStyles: { fillColor: [56, 178, 172] }
  });

  doc.save(`${popupTitle.replace(/\s+/g, "_")}.pdf`);
};






const RenderNode = ({ node }) => {
  const inchargeKey = `incharge_${node.emp_id}`;
  const hodKey = `hod_${node.emp_id}`;

  return (
    <TreeNode
      label={
        <NodeCard
          name={node.name}
          department={node.department}
          emp_id={node.emp_id}
          incharge_id={node.incharge_id}
          hod_id={node.hod_id}
          onExpand={node.type === "HOD" ? handleHodExpand : handleInchargeExpand}
          highlight={searchValue && employeeMatch(node)}
        />
      }
    >
      {/* LEFT → HOD children */}
      {expanded[hodKey] &&
        (childrenMap[hodKey] || []).map(child => (
          <RenderNode key={`hod_${child.emp_id}`} node={child} />
        ))}

      {/* RIGHT → INCHARGE children */}
      {expanded[inchargeKey] &&
        (childrenMap[inchargeKey] || []).map(child => (
          <RenderNode key={`in_${child.emp_id}`} node={child} />
        ))}
    </TreeNode>
  );
};




function normalize(val = "") {
  return val.toString().toLowerCase().trim();
}

const employeeMatch = (emp) => {
  const q = normalize(searchValue);

  return (
    normalize(emp.name).includes(q) ||
    normalize(emp.emp_id).includes(q) ||

    normalize(emp.hod_name).includes(q) ||
    normalize(emp.hod_id).includes(q) ||

    normalize(emp.incharge_name).includes(q) ||
    normalize(emp.incharge_id).includes(q)
  );
};


// const searchResults = React.useMemo(() => {
//   if (!searchValue || !orgTree) return [];

//   const results = [];

//   orgTree.children.forEach(group => {
//     group.children.forEach(emp => {
//       if (
//         normalize(emp.hod_name).includes(normalize(searchValue)) ||
//         normalize(emp.hod_id).includes(normalize(searchValue)) ||
//         normalize(emp.incharge_name).includes(normalize(searchValue)) ||
//         normalize(emp.incharge_id).includes(normalize(searchValue))
//       ) {
//         results.push(emp);
//       }
//     });
//   });

//   return results;
// }, [searchValue, orgTree]);



const [menuOpenFor, setMenuOpenFor] = useState(null);
const [showReporterPopup, setShowReporterPopup] = useState(false);
const [activeManager, setActiveManager] = useState(null);


const [reporteeSearch, setReporteeSearch] = useState("");
const [reporteeList, setReporteeList] = useState([]);
const [selectedReportee, setSelectedReportee] = useState(null);
const [showReporteeDropdown, setShowReporteeDropdown] = useState(false);

useEffect(() => {
  if (!showReporterPopup) return;

  axios
    .get(`${API_BASE_URL}/without_approval_employees`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    })
    .then(res => {
      setReporteeList(res.data.data || []);
    })
    .catch(err => {
      console.error("Failed to load reportees", err);
    });
}, [showReporterPopup]);

const filteredReportees = reporteeList.filter(emp =>
  `${emp.first_name} ${emp.last_name} ${emp.employee_id}`
    .toLowerCase()
    .includes(reporteeSearch.toLowerCase())
);


const [showModal, setShowModal] = useState(false);
const [reportees, setReportees] = useState([]);
// const [activeManager, setActiveManager] = useState(null);
// const [loading, setLoading] = useState(false);

useEffect(() => {
  if (showReporterPopup && activeManager?.emp_id) {
    handleInchargeExpand(
      activeManager.emp_id,
      activeManager.name,
      false   // 👈 DO NOT open expand popup
    );
  }
}, [showReporterPopup, activeManager]);



	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							{/* <div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action">
									<div id="button">
										<button style={{ float: 'center' }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											onClick={()=>{setUser(emptyUser)}}
										>
											<i className="fe fe-plus mr-2" />
											Add
										</button>
									</div>
								</div>
							</div> */}

						</div>
					</div>


					<div className="section-body" ref={sectionRef}>
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title" style={{ color: '#e96827' }}>Organization Tree</h3>
											
										</div>


										{loading && <p>Loading...</p>}

{orgTree && (
  <div className="org-tree-wrapper">
  <div className="org-tree"  ref={treeRef}
  style={{
    transform: `scale(${zoom})`,
    transformOrigin: "top center",
    transition: "transform 0.2s ease"
  }}>
   <div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px"
  }}
>

 {/* Right side – Zoom controls */}
  <div className="zoom-controls" style={{ display: "flex", gap: "8px" }}>
    <button
      onClick={() => {
        if (!sectionRef.current || !treeRef.current) return;

        const sectionWidth = sectionRef.current.offsetWidth;
        const treeWidth = treeRef.current.scrollWidth;
        const maxZoom = sectionWidth / treeWidth;

        setZoom((z) => Math.min(z + 0.1, maxZoom));
      }}
    >
      ＋
    </button>

    <button onClick={() => setZoom((z) => Math.max(z - 0.1, 0.5))}>
      －
    </button>
  </div>

  {/* Left side – Search */}
  <div>
    <input
      type="text"
      placeholder="Search by Employee Name or Emp ID"
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
      style={{
        width: "250px",
        padding: "6px 10px",
        borderRadius: "6px",
        border: "1px solid #ccc"
      }}
    />
    {searchValue && searchResults.length > 0 && (
  <div
    style={{
      position: "absolute",
      background: "#fff",
      border: "1px solid #ddd",
      width: "250px",
      maxHeight: "200px",
      overflowY: "auto",
      zIndex: 1000,
      borderRadius: "6px",
      marginTop: "4px"
    }}
  >
    {searchResults.map(emp => (
      <div
        key={emp.emp_id}
        style={{
          padding: "8px",
          cursor: "pointer",
          borderBottom: "1px solid #eee"
        }}
       onClick={() => {
  setSearchValue(emp.name);
  setSelectedEmpId(emp.emp_id);
  setTimeout(() => {
    setSearchValue("");
  }, 200);
  
}}


      >
        <strong>{emp.name} ({emp.emp_id})</strong>
        {/* <div style={{ fontSize: "12px", color: "#666" }}>
          HOD: {emp.hod_name} ({emp.hod_id})
        </div>
        <div style={{ fontSize: "12px", color: "#666" }}>
          In-Charge: {emp.incharge_name} ({emp.incharge_id})
        </div> */}
      </div>
    ))}
  </div>
)}

  </div>

 
</div>




  <Tree
    lineWidth="2px"
    lineColor="#cbd5e0"
    lineBorderRadius="10px"
    label={
      <NodeCard
        name={orgTree.name}
        department={orgTree.department}
        emp_id={orgTree.emp_id}
      />
    }
  >



{orgTree.children.map(group => {
const isInchargeGroup = group.group === "INCHARGE GROUP";
  const isHodGroup = group.group === "HOD GROUP";
  const groupHasMatch = group.children.some(emp =>
    employeeMatch(emp)
  );
let firstMatchFound = false;
  return (
    
    <TreeNode
      key={group.group}
      label={
        <Card
          className={`group-title ${
            searchValue && groupHasMatch ? "group-highlight" : ""
          }`}
        >
          {group.group}
        </Card>
      }
    >
      {group.children.map(emp => {
        const isMatch = searchValue && employeeMatch(emp);

        let refProp = null;
        if (isMatch && !firstMatchFound) {
          refProp = firstMatchRef;
          firstMatchFound = true;
        }

        return (
          <TreeNode
      key={emp.emp_id}
      label={
        <NodeCard
          name={emp.name}
          department={emp.department}
          emp_id={emp.emp_id}
          canExpand
          onExpand={
            isInchargeGroup
              ? handleInchargeExpand
              : isHodGroup
              ? handleHodExpand
              : null
          }
          highlight={emp.emp_id === selectedEmpId}
          nodeRef={refProp}
          onAddReporter={(manager) => {
          setActiveManager(manager);
          setShowReporterPopup(true);
        }}
        />
      }
    />
        );
      })}
    </TreeNode>
  );
})}


  </Tree>
</div>
</div>

)}



















										
										
										



									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>



{showReporterPopup && (
  <div className="popup-overlay">
    <div className="popup-modal" style={{ width: "500px" }}>
      <div className="popup-header">
        <h4>Add Reportee(s)</h4>
        <button onClick={() => setShowReporterPopup(false)}>✕</button>
      </div>

      <div className="popup-body">
        <div style={{ marginBottom: "10px" }}>
          <label>Select Manager</label>
          <input
            value={`${activeManager?.name} (${activeManager?.emp_id})`}
            disabled
            style={{ width: "100%", padding: "6px" }}
          />
        </div>

        <div style={{ marginBottom: "10px" }}>
          <label>Select Reportee</label>
          <div style={{ position: "relative" }}>
  <input
    placeholder="Search employee"
    value={reporteeSearch}
    onChange={(e) => {
      setReporteeSearch(e.target.value);
      setShowReporteeDropdown(true);
    }}
    style={{ width: "100%", padding: "6px" }}
  />

  {showReporteeDropdown && reporteeSearch && filteredReportees.length > 0 && (
    <div
      style={{
        position: "absolute",
        top: "36px",
        left: 0,
        right: 0,
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: "6px",
        maxHeight: "180px",
        overflowY: "auto",
        zIndex: 3000
      }}
    >
      {filteredReportees.map(emp => (
        <div
          key={emp.user_id}
          style={{
            padding: "8px",
            cursor: "pointer",
            borderBottom: "1px solid #eee"
          }}
          onClick={() => {
            setSelectedReportee(emp);
            setReporteeSearch(
              `${emp.first_name} ${emp.last_name} (${emp.employee_id})`
            );
            setShowReporteeDropdown(false);
          }}
        >
          <div style={{ fontWeight: "600" }}>
            {emp.first_name} {emp.last_name}
          </div>
          <div style={{ fontSize: "12px", color: "#666" }}>
            Emp ID: {emp.employee_id}
          </div>
        </div>
      ))}
    </div>
  )}
</div>

          <button
  disabled={!selectedReportee}
  onClick={() => {
    console.log("Manager:", activeManager);
    console.log("Reportee:", selectedReportee);

    // TODO: call API to save reporter
    // axios.post('/add-reportee', { manager_id, reportee_id })
  }}
  style={{
    marginTop: "6px",
    background: selectedReportee ? "#4f46e5" : "#ccc",
    color: "#fff",
    padding: "6px 10px",
    borderRadius: "4px",
    cursor: selectedReportee ? "pointer" : "not-allowed"
  }}
>
  Add Selected Reportee
</button>

        </div>

        <hr />

        <h5>All Reportees</h5>

<table width="100%">
  <thead>
    <tr>
      <th align="left">Employee</th>
      {/* <th align="left">Reporting From</th> */}
    </tr>
  </thead>

  <tbody>
  {reportees.length > 0 ? (
    reportees.map((emp, index) => (
      <tr key={emp.user_id || emp.emp_id || index}>
        <td>
          {(emp.employee_name ||
            emp.name ||
            `${emp.first_name || ""} ${emp.last_name || ""}`.trim()
          ) || "-"}
          {" "}
          (
          {emp.employee_id || emp.emp_id || "-"}
          )
        </td>
        {/* <td>
          {emp.reporting_from
            ? new Date(emp.reporting_from).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            : "-"}
        </td> */}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="2">No reportees found</td>
    </tr>
  )}
</tbody>


</table>

      </div>

      <div className="popup-footer">
        <button onClick={() => setShowReporterPopup(false)}>Cancel</button>
        <button className="btn-primary">Save</button>
      </div>
    </div>
  </div>
)}


			
			
{showPopup && (
  <div className="popup-overlay">
    <div className="popup-modal">
      <div className="popup-header">
        <h4 style={{ fontSize: '16px',color: '#1518cc',fontWeight: '600',margin:'10px' }}>{popupTitle}</h4>
        <div className="popup-actions">
    {/* <button className="download-btn" onClick={downloadPDF}>
      ⬇ Download PDF
    </button> */}
    <i class="fa-solid fa-download fa-2x"  onClick={downloadPDF}
  style={{ cursor: "pointer" }}></i>

    <button  onClick={() => setShowPopup(false)}>
      ✕
    </button>
  </div>

      </div>

      <div className="popup-body">
  {popupEmployees.length === 0 ? (
    <p>No employees found</p>
  ) : (
    popupEmployees.map(emp => (
      <div key={emp.emp_id} className="popup-employee-card">
        <strong>{emp.name}</strong>
        <div>{emp.department}</div>
        <small>Emp ID - {emp.emp_id}</small>
      </div>
    ))
  )}
</div>

    </div>
  </div>
)}






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(Organzationtree);